import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34aa67a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createTextVNode(" Copyright © 2014 Thought Leaders Pty Ltd. "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://cdn1.thoughtleaders.com.au/ThoughtLeadersPrivacyPolicy.Latest.pdf",
        target: "_blank",
        class: "no-style"
      }, "Privacy"),
      /*#__PURE__*/_createTextVNode(". ")
    ])
  ])
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_component = _resolveComponent("logo-component")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AuthAdminComponent = _resolveComponent("AuthAdminComponent")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("nav", null, [
          _createVNode(_component_logo_component),
          _createElementVNode("menu", null, [
            _createElementVNode("ul", null, [
              _createVNode(_component_AuthAdminComponent, null, {
                default: _withCtx(() => [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/admin" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Admin ")
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ])
    ]),
    _hoisted_3
  ], 64 /* STABLE_FRAGMENT */))
}